import styled from 'styled-components'

export const ReferenceImagesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`
